document.addEventListener('DOMContentLoaded', () => {

  /* =========================================
     PRODUCT / FORM
     ========================================= */

  const form = document.querySelector('#tm-product-form');
  const variantInput = document.querySelector('#tm-variant-id');
  const variantsElement = document.querySelector('[data-product-variants]');

  if (!form) return;

  const variants = variantsElement
    ? JSON.parse(variantsElement.textContent)
    : [];


  /* =========================================
     VARIANTE ACTUAL
     ========================================= */

  let selectedVariant = variants.find(
    variant => String(variant.id) === String(variantInput?.value)
  ) || variants[0];


  /* =========================================
     ELEMENTOS
     ========================================= */

  const sizeGroup = document.querySelector('[data-size-group]');

  const qtyValue = document.querySelector('[data-qty-value]');
  const qtyInput = document.querySelector('#tm-quantity');
  const qtyMinus = document.querySelector('[data-qty-minus]');
  const qtyPlus = document.querySelector('[data-qty-plus]');

  const totalElements = document.querySelectorAll(
    '[data-total], [data-total-sticky]'
  );

  const resumenLinea = document.querySelector('[data-resumen-linea]');

  const submitButtons = form.querySelectorAll('[type="submit"]');


  /* =========================================
     CANTIDAD
     ========================================= */

  let qty = parseInt(qtyInput?.value || '1', 10);


  /* =========================================
     FORMATEAR PRECIO
     ========================================= */

  function formatPrice(price) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2
    }).format(price / 100);
  }


  /* =========================================
     ACTUALIZAR TOTAL
     ========================================= */

  function updateTotal() {

    if (!selectedVariant) return;

    const total = selectedVariant.price * qty;

    totalElements.forEach(element => {
      element.textContent = formatPrice(total);
    });

  }


  /* =========================================
     ACTUALIZAR RESUMEN STICKY
     ========================================= */

  function updateResumen() {

    if (!resumenLinea || !selectedVariant) return;

  const variantName = selectedVariant.options.join(' / ');

  resumenLinea.textContent =
    `${variantName} · ${qty} pieza(s) · envío gratis`;

  }


  /* =========================================
     ACTUALIZAR ESTADO DE VARIANTE
     ========================================= */

  function updateVariant(variant) {

    if (!variant) return;

    selectedVariant = variant;

    /* -------------------------
       Hidden variant ID
       ------------------------- */

    if (variantInput) {
      variantInput.value = variant.id;
    }


    /* -------------------------
       Botones de submit
       ------------------------- */

    submitButtons.forEach(button => {

      button.disabled = !variant.available;

      if (!variant.available) {
        button.textContent = 'Agotado';
      } else if (button.classList.contains('add-btn--pdp')) {
        button.innerHTML =
          `Agregar a la bolsa — <span data-total></span>`;
      } else {
        button.textContent = 'Comprar ahora';
      }

    });


    /* -------------------------
       Actualizar precio
       ------------------------- */

    updateTotal();


    /* -------------------------
       Actualizar sticky
       ------------------------- */

    updateResumen();

  }


  /* =========================================
     SELECCIÓN DE VARIANTE
     ========================================= */

  if (sizeGroup && variants.length) {

    const options = sizeGroup.querySelectorAll(
      '[data-option-value]'
    );

    options.forEach(option => {

      option.addEventListener('click', () => {

        /* -------------------------
           UI selected
           ------------------------- */

        options.forEach(item => {
          item.classList.remove('selected');
        });

        option.classList.add('selected');


        /* -------------------------
           Valor seleccionado
           ------------------------- */

        const selectedValue =
          option.dataset.optionValue;


        /* -------------------------
           Buscar variante
           ------------------------- */

        const variant = variants.find(
          variant =>
            variant.options.includes(selectedValue)
        );


        console.log('Medida:', selectedValue);
        console.log('Variante:', variant);


        if (!variant) return;


        /* -------------------------
           Actualizar variante
           ------------------------- */

        updateVariant(variant);

      });

    });

  }


  /* =========================================
     QUANTITY
     ========================================= */

  if (qtyMinus && qtyPlus && qtyValue && qtyInput) {

    qtyMinus.addEventListener('click', (event) => {

      event.preventDefault();

      qty = Math.max(1, qty - 1);

      qtyValue.textContent = qty;
      qtyInput.value = qty;

      updateTotal();
      updateResumen();

    });


    qtyPlus.addEventListener('click', (event) => {

      event.preventDefault();

      qty = Math.min(10, qty + 1);

      qtyValue.textContent = qty;
      qtyInput.value = qty;

      updateTotal();
      updateResumen();

    });

  }


  /* =========================================
     FAQS
     ========================================= */

  document.querySelectorAll('[data-faq]').forEach(item => {

    item.addEventListener('click', () => {

      const wasOpen =
        item.classList.contains('open');


      document.querySelectorAll('[data-faq]').forEach(i => {

        i.classList.remove('open');

        const sign =
          i.querySelector('.faq-item__sign');

        if (sign) {
          sign.textContent = '+';
        }

      });


      if (!wasOpen) {

        item.classList.add('open');

        const sign =
          item.querySelector('.faq-item__sign');

        if (sign) {
          sign.textContent = '–';
        }

      }

    });

  });

  /* =========================================
   GALERÍA / THUMBS
   ========================================= */

    const thumbs = document.querySelectorAll('[data-thumb]');
    const mainImage = document.querySelector('[data-main-image]');

    if (thumbs.length && mainImage) {

      thumbs.forEach(thumb => {

        thumb.addEventListener('click', () => {

          const imageUrl = thumb.dataset.imageUrl;

          if (!imageUrl) return;

          /* -------------------------
            Active thumb
            ------------------------- */

          thumbs.forEach(item => {
            item.classList.remove('active');
          });

          thumb.classList.add('active');


          /* -------------------------
            Imagen principal
            ------------------------- */

          mainImage.innerHTML = `
            <img
              src="${imageUrl}"
              alt=""
              loading="eager"
            >
          `;

        });

      });

    }


  /* =========================================
     ESTADO INICIAL
     ========================================= */

  if (selectedVariant) {

    updateVariant(selectedVariant);

  }

});